import {
    AD_SLOT_REFRESH,
    AD_SLOT_RENDER_ENDED,
    AdSlotRefreshAction,
    AdSlotRenderEndedAction,
} from "@/mk2/containers/AdSlot/AdSlot.actions";

export interface AdSlotOffsiteState {
    show: boolean;
}

export const initialAdSlotOffsiteState: AdSlotOffsiteState = {
    show: false,
};

type AdSlotActions = AdSlotRenderEndedAction | AdSlotRefreshAction;

export const adSlotOffsiteReducer = (
    state: AdSlotOffsiteState = initialAdSlotOffsiteState,
    action: AdSlotActions,
) => {
    switch (action.type) {
        case AD_SLOT_REFRESH:
            if (!action.slotId.startsWith("mk-branding")) {
                return state;
            }

            return {
                ...state,
                // this slot has been scheduled for refresh - hide slot
                show: false,
            };
        case AD_SLOT_RENDER_ENDED:
            // We handle only branding
            if (!action.slotId.startsWith("mk-branding")) {
                return state;
            }

            // Display offsite when branding is empty or branding width is <= 980
            const show =
                action.event.isEmpty ||
                !Array.isArray(action.event.size) ||
                action.event.size[0] <= 980;

            return {
                ...state,
                show,
            };
        default:
            return state;
    }
};
